import { connect } from 'react-redux';
import { PackageType } from '../../../../constants/inventory/InventoryTypes';
import { resetFormPackageItems } from '../../../../redux/Inventory/actions';
import { createInventoryPackage } from '../../../../redux/Inventory/sagas/package/routines';
import CreateInventoryItem from '..';

function mapStateToProps(_, props) {
  return {
    ...props,
    type: PackageType
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(resetFormPackageItems());
    },
    onSubmit: body => {
      dispatch(createInventoryPackage(body));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateInventoryItem);
